import { post } from '@apps-once/request/once-v2-api';

export interface PreviewPricingRequest {
  hostname: string;
  productIdentifier: string;
  quantity: number;
  forceFresh?: boolean;
}

export interface PreviewPricingLineItem {
  identifier: string;
  unitPrice: string;
  quantity: number;
  amount: string;
  taxAmount: string;
  source?: string;
}

export interface PreviewPricingData {
  source: string;
  productIdentifier: string;
  currency: string;
  period: string;
  subscriptionTermType: string;
  recurring: PreviewPricingLineItem[];
  oneTime: PreviewPricingLineItem[];
  recurringTotal: string;
  oneTimeTotal: string;
  // Server-minted UUIDv4 echoed back at commit for the snapshot drift gate.
  // BE writes this into BillingPreviewSnapshotCache keyed by (tenantId, sessionId)
  // and rejects mismatching commits with HTTP 409 PAYROLL_CHECKOUT_DRIFT.
  checkoutSessionId: string;
}

export interface PreviewPricingResponse {
  success: boolean;
  message: string;
  data: PreviewPricingData;
}

export async function previewPricing(
  payload: PreviewPricingRequest
): Promise<PreviewPricingResponse> {
  const response = await post('/once/v2/billing:preview-pricing', {
    data: payload,
  });
  return response.data;
}
